/* JMB personalization cart sync.
   Each paid "Personalization" line carries a hidden _pers_id that matches the item it
   belongs to. Keep its quantity equal to that item's, and remove it if the item is gone. */
(function () {
  if (window.__jmbCartSync) return;
  window.__jmbCartSync = true;
  var busy = false;
  var root = (window.theme && window.theme.routes ? window.theme.routes.root_url : '/');

  function post(url, data) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function sync(cart) {
    if (busy || !cart || !cart.items) return;
    var fixes = [];
    cart.items.forEach(function (line) {
      if (line.handle !== 'personalization') return;
      var pid = line.properties && line.properties._pers_id;
      var owner = cart.items.find(function (i) {
        return i.handle !== 'personalization' && i.properties && i.properties._pers_id === pid;
      });
      var want = owner && pid ? owner.quantity : 0;
      if (line.quantity !== want) fixes.push({ id: line.key, quantity: want });
    });
    if (!fixes.length) return;
    busy = true;
    fixes.reduce(function (p, f) {
      return p.then(function () { return post('cart/change.js', f); });
    }, Promise.resolve()).then(function () {
      return fetch(root + 'cart.js').then(function (r) { return r.json(); });
    }).then(function (fresh) {
      busy = false;
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: fresh }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    }).catch(function () { busy = false; });
  }

  document.addEventListener('theme:cart:change', function (e) {
    sync(e.detail && e.detail.cart);
  });
})();

/* JMB: also load assets/jmb-variant-fallback.js (picks the nearest real variant when a colour/option
   click lands on a combination that doesn't exist, e.g. DAWN 2 Wallet colour vs. leather).
   Loaded from here so layout/theme.liquid stays untouched. Bump "fb=" after editing that file. */
(function () {
  var me = document.currentScript && document.currentScript.src;
  if (!me || document.querySelector('script[data-jmb-variant-fallback]')) return;
  var s = document.createElement('script');
  s.src = me.replace('jmb-cart-sync.js', 'jmb-variant-fallback.js') + (me.indexOf('?') > -1 ? '&' : '?') + 'fb=2';
  s.defer = true;
  s.setAttribute('data-jmb-variant-fallback', '');
  document.head.appendChild(s);
})();
